ISMDSPlugin.define('src/js/data/SummaryData',['_', 'promise', './../util/util', './../util/validation', './../templates/templateSettings'], function (_, Promise, util, Validation, settings) {
  var SummaryData = {};

  var withinRange = function withinRange(percentage, low, high) {
    var isWithin = percentage > low && percentage <= high,
      isZeroRange = low === 0 && high === percentage;
    return isWithin || isZeroRange;
  };

  var getRangeName = function getRangeName(percentage, ranges) {
    var rangeNames = Object.keys(ranges),
      rangesLength = rangeNames.length,
      rangeName,
      range,
      isWithinRange,
      index;

    for (index = 0; index < rangesLength; index++) {
      rangeName = rangeNames[index];
      range = ranges[rangeName];
      isWithinRange = withinRange(percentage, range.lowRange, range.highRange);

      if (isWithinRange) {
        return rangeName;
      }
    }
    return null;
  };

  var createRangeModel = function (ranges, lowRange, highRange) {
    var name = (lowRange * 100) + '%-' + (highRange * 100) + '%';
    var rangeModel = {
      name: name,
      lowRange: lowRange,
      highRange: highRange,
      interiorColor: ranges[highRange]
    };
    return rangeModel;
  };

  var createRangeModels = function (validatedRanges, rangeValues) {
    var ranges = {},
      lowRange = 0,
      length = rangeValues.length,
      index;
    for (index = 0; index < length; index++) {
      var range = rangeValues[index];
      var highRange = parseFloat(range);
      var rangeModel = createRangeModel(validatedRanges, lowRange, highRange);
      ranges[rangeModel.name] = rangeModel;
      lowRange = highRange;
    }
    return ranges;
  };

  var createRanges = function (ranges) {
    if (_.isEmpty(ranges)) {
      return settings.Segment;
    }

    var result = Validation.validateRange(ranges);
    var rangeValues = _.keys(result, 'range').sort();

    return createRangeModels(result, rangeValues);
  };

  var getFaceRange = function (inventoryType) {
    var faceRange = {
      min: undefined,
      max: undefined
    };
    if (inventoryType) {
      if (inventoryType.faceRange) {
        faceRange = inventoryType.faceRange[0];
      }
    }
    return faceRange;
  };

  var parseResaleMinPrice = function (data) {
    var resale = getFaceRange(_.find(data, {
      inventoryTypes: ['resale']
    }));
    var primary = getFaceRange(_.find(data, {
      inventoryTypes: ['primary']
    }));
    var min = util.min(primary.min, resale.min);
    var max = util.max(primary.max, resale.max);
    return {
      min: min,
      max: max
    }
  };

  var parsePrimaryMinPrice = function (data) {
    var faceRange = getFaceRange(data);
    return {
      min: faceRange.min,
      max: faceRange.max
    };
  };

  var parseMinPrice = function (resaleEnabled, data) {
    var result;
    if (resaleEnabled) {
      result = parseResaleMinPrice(data);
    } else {
      result = parsePrimaryMinPrice(data[0]);
    }

    var suffix = result.min === result.max ? '' : '+';
    return ['$', result.min.toFixed(2), suffix].join('');
  };

  var setSummaryData = function (resaleEnabled, segment, information, ranges) {
    segment.placesAvailable = util.pluck(information, 'count')
      .reduceRight(function (a, b) {
        return a + b;
      });
    var percentage = segment.placesAvailable / segment.totalPlaces;
    segment.availability = getRangeName(percentage, ranges);
    segment.minPrice = parseMinPrice(resaleEnabled, information);
  };

  var unSetMinPrice = function (core, segmentIds) {
    var index,
      length = segmentIds.length;
    for (index = 0; index < length; index++) {
      var segmentId = segmentIds[index];
      var segment = core.data.segmentsById[segmentId];
      segment.minPrice = 'N/A';
    }
  };

  var parseSummaryData = function (plugin, data, ranges) {
    var index,
      core = plugin.core,
      resaleEnabled = plugin.resaleEnabled,
      updatedSegments = [],
      keys = Object.keys(data),
      length = keys.length;
    for (index = 0; index < length; index++) {
      var segmentId = keys[index];
      var facet = data[segmentId];
      var segment = core.data.segmentsById[segmentId];
      if (!segment) {
        return;
      }
      updatedSegments.push(segmentId);
      setSummaryData(resaleEnabled, segment, facet, ranges);
    }
    var allSegments = Object.keys(core.data.segmentsById);
    var untouchedSegments = _.difference(allSegments, updatedSegments);
    if (untouchedSegments.length) {
      unSetMinPrice(core, untouchedSegments);
    }


  };

  SummaryData.init = function (core, ranges) {
    this.ranges = createRanges(ranges || []);
    var lowestRange = _.findKey(this.ranges, _.min(this.ranges, 'highRange'));
    core.Segment.addPluginProperty('availability', lowestRange, true);
    core.Segment.addPluginProperty('placesAvailable', 0, false);
    core.Segment.addPluginProperty('minPrice', 'N/A', true);
    core.Segment.addPluginProperty('offers', [], false);
  };

  SummaryData.getData = function getData(plugin) {
    var getSummaryData = plugin.urlBuilder.getSummaryData,
      ranges = this.ranges,
      core = plugin.core;
    core.emit('summary-availability-update-started');
    core.startLoading();
    return getSummaryData(plugin.resaleEnabled, plugin.platinumEnabled)
      .then(function (data) {
        parseSummaryData(plugin, _.groupBy(data.facets, 'shapes'), ranges);
        core.emit('summary-availability-update-complete');
        core.finishLoading();
      });
  };

  SummaryData.getSummaryData = function getSummaryData(plugin, summaryUpdateInterval) {
    var self = this;
    return this.getData(plugin)
      .then(function () {
        return Promise.delay(summaryUpdateInterval);
      })
      .then(function () {
        return getSummaryData.call(self, plugin, summaryUpdateInterval);
      });
  };
  return SummaryData;
});

